import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiAxios from 'helpers/apiAxios';

const URL = '/booking/car/dashboard';

export const getCarDashboard = createAsyncThunk(
  'CarDashboard/get',
  async (params, { rejectWithValue }) => {
    try {
      const response = await apiAxios.get(URL, { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || { message: 'Failed to load car dashboard' });
    }
  },
);

export const getCarDrilldown = createAsyncThunk(
  'CarDashboard/drilldown',
  async (params, { rejectWithValue }) => {
    try {
      const response = await apiAxios.get(`${URL}/drilldown`, { params });
      return response.data || { rows: [], total_rows: 0 };
    } catch (error) {
      return rejectWithValue(error?.response?.data || { message: 'Failed to load detail' });
    }
  },
);

export const exportCarDrilldown = createAsyncThunk(
  'CarDashboard/drilldownExport',
  async (params) => {
    const response = await apiAxios.get(`${URL}/drilldown_export`, { params, responseType: 'blob' });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `car-detail-${params?.dimension || 'all'}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  },
);

const initialState = {
  data: { stats: {}, by_status: [], by_driver: [], by_car: [], monthly_trend: [], upcoming: [] },
  loading: false,
  error: null,
};

const carDashboardSlice = createSlice({
  name: 'car_dashboard',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCarDashboard.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(getCarDashboard.fulfilled, (state, action) => { state.loading = false; state.data = action.payload; })
      .addCase(getCarDashboard.rejected, (state, action) => { state.loading = false; state.error = action.payload?.message; });
  },
});

export default carDashboardSlice.reducer;
